<template>
  <div>
    <h1>Bem Vindo ao Módulo de {{ nomeMenu }}</h1>
  </div>
</template>

<script>
import { modalLoginSSO } from '../../../utils/sso';
import { getModuloMenuSelecionado } from '../../../utils/index';
export default {
  name: 'PageInicio',
  props: {
    msg: String,
  },
  data() {
    return {
      texto: '',
      nomeMenu: getModuloMenuSelecionado(),
    };
  },
  async created() {},

  methods: {},
  setup() {
    const teste = () => {
      modalLoginSSO();
    };

    return {
      teste,
    };
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.custom-card {
  transition: border 0.3;
  /* Adiciona uma transição suave para a mudança de borda */
  cursor: pointer;
}

.custom-card:hover {
  border: 2px solid #007bff;
  /* Cor e espessura da borda no hover */
}
</style>
